import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/**
 *
 * @param {string} op The operation did
 * @param {object} objectStore The IDBObjectStore object
 * @param {object} data The data passed in
 */
var cud = function cud(op, objectStore, data) {
  return new Promise(function (resolve, reject) {
    var request = objectStore[op](data);

    request.onsuccess = function (event) {
      return resolve(event);
    };

    request.onerror = function (err) {
      return reject(err);
    };
  });
};

var ByIndexDB = /*#__PURE__*/function () {
  function ByIndexDB(dbName) {
    var dbVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var onUpgrade = arguments.length > 2 ? arguments[2] : undefined;
    var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, ByIndexDB);

    this.idbInvalid = window.indexedDB === null || window.indexedDB === undefined;
    this.dbName = dbName;
    this.dbVersion = dbVersion;
    this.onUpgrade = onUpgrade;
    this.opts = _objectSpread({}, opts);
    this.db = null; // FIXME: To avoid error report from firefox's private window
    // FIXME: Should add localStorage or other tools to take over the storage task later.

    this.dbInitPromise = this.idbInvalid ? Promise.reject('IDB not support!') : this.initDB();
    this.dbInitPromise.catch(this.handleCompatibleError.bind(this));
  }
  /**
   * Init DB
   */


  _createClass(ByIndexDB, [{
    key: "initDB",
    value: function initDB() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var dbName = _this.dbName,
            dbVersion = _this.dbVersion,
            onUpgrade = _this.onUpgrade;
        var request = window.indexedDB.open(dbName, dbVersion);

        request.onsuccess = function () {
          _this.db = request.result;

          _this.db.onversionchange = function () {
            if (_this.db) {
              _this.db.close();

              window.location.reload();
            }
          };

          resolve(_this.db);
        };

        request.onerror = function (event) {
          // if (
          //   request.error
          //   && (
          //     request.error.name === 'InvalidStateError'
          //     || request.error.name === 'UnknownError'
          //   )
          // ) {
          //   this.idbInvalid = true;
          //   reject(event);
          //   return;
          // }
          var errorMsg = event.target && event.target.error; // FIXME: Just add this for code debug

          console.warn('Idb open error: ', errorMsg); // eslint-disable-line

          reject(event);
        };

        request.onupgradeneeded = function (event) {
          if (onUpgrade) onUpgrade(event.target.result);
        };
      });
    }
    /**
     * Get transaction promise
     *
     * @param {array} tables The tables to get transaction
     * @param {string} permission The permission needed, readwrite|readonly
     */

  }, {
    key: "getTx",
    value: function getTx(table, permission) {
      var _this2 = this;

      try {
        return Promise.resolve(this.db.transaction(table, permission).objectStore(table));
      } catch (err) {
        // FIXME: Chrome always close connection here.
        // TODO: Can be updated here if chrome do changes.
        var errorMsg = err.target && err.target.error;
        console.warn('Idb get tx error ', errorMsg); // eslint-disable-line

        this.dbInitPromise = this.initDB();
        return this.dbInitPromise.then(function () {
          return _this2.getTx(table, permission);
        });
      }
    }
    /**
     * Handle idb compatible issue.
     *
     * @param {object} error The Index error event
     */

  }, {
    key: "handleCompatibleError",
    value: function handleCompatibleError() {
      this.idbInvalid = false;
      console.warn('Can\'t open IDB, your browser doesn\'t support idb storage!'); // eslint-disable-line
    }
    /**
     * Insert records to specific objectStore
     *
     * @param {object} table The objectStore which need to insert
     * @param {string|number|object|array} record The records need to insert
     */

  }, {
    key: "insert",
    value: function insert(table) {
      var _this3 = this;

      var record = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return this.dbInitPromise.then(function () {
        return _this3.cudTx(table, record, 'add');
      }).catch(this.handleCompatibleError.bind(this));
    }
    /**
     * Query the head counts records
     *
     * @param {object} table The objectStore need to query data
     * @param {number} num The head number need to query out
     */

  }, {
    key: "head",
    value: function head(table) {
      var _this4 = this;

      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
      return this.dbInitPromise.then(function () {
        return new Promise(function (resolve) {
          var headMap = {};
          var n = num; // const objectStore = this.getTx(table, 'readonly').objectStore(table);

          return _this4.getTx(table, 'readonly').then(function (objectStore) {
            objectStore.openCursor().onsuccess = function (event) {
              var cursor = event.target.result;
              n -= 1;

              if (cursor) {
                headMap[cursor.key] = cursor.value;
                if (n > 0) cursor.continue();else resolve(headMap);
              } else {
                resolve(headMap);
              }
            };
          }).catch(function (err) {
            var errorMsg = err.target && err.target.error;
            console.warn('Idb head error ', errorMsg); // eslint-disable-line

            _this4.dbInitPromise = _this4.initDB();
            return _this4.dbInitPromise.then(function () {
              return _this4.head(table, num).then(resolve);
            });
          });
        });
      }).catch(function (error) {
        _this4.handleCompatibleError(error); // Add this to Avoid loop query.


        return [];
      });
    }
    /**
     * Delete records
     *
     * @param {string} table The objectStore which need to delete records
     * @param {string|number|array} candidate The key or key list which need to delete
     */

  }, {
    key: "delete",
    value: function _delete(table, candidate) {
      var _this5 = this;

      return this.dbInitPromise.then(function () {
        return _this5.cudTx(table, candidate, 'delete');
      }).catch(this.handleCompatibleError.bind(this));
    }
    /**
     * get records
     *
     * @param {string} table The objectStore which need to delete records
     * @param {string|number|array} candidate The key or key list which need to delete
     */

  }, {
    key: "get",
    value: function get(table, candidate) {
      var _this6 = this;

      return this.dbInitPromise.then(function () {
        return _this6.cudTx(table, candidate, 'get');
      }).catch(this.handleCompatibleError.bind(this));
    }
    /**
     * Batch transaction function
     *
     * @param {object} table The object store name.
     * @param {any} record The records need to deal
     * @param {string} op The operate, may `add`, `delete`, `put`.
     */

  }, {
    key: "cudTx",
    value: function cudTx(table, record, op) {
      var _this7 = this;

      return this.getTx(table, 'readwrite').then(function (objectStore) {
        var isBatch = Array.isArray(record);
        var opPromise;

        if (isBatch) {
          var batchCud = record.map(function (obj) {
            return cud(op, objectStore, obj);
          });
          opPromise = Promise.all(batchCud);
        } else {
          opPromise = cud(op, objectStore, record);
        }

        return opPromise.catch(function (err) {
          var errorMsg = err.target && err.target.error;
          console.warn("Idb ".concat(op, " err "), errorMsg); // eslint-disable-line

          _this7.dbInitPromise = _this7.initDB();
          return _this7.dbInitPromise.then(function () {
            return _this7.cudTx(table, record, op);
          });
        });
      });
    }
  }]);

  return ByIndexDB;
}();

export { ByIndexDB as default };